/* global  window  */
import AmplitudeClient from "amplitude-js";

let amplitude = null;
if (
  typeof window.Castos !== "undefined" &&
  window.Castos?.config?.amplitudeKey &&
  window.Castos.config.amplitudeKey.length
) {
  const API_KEY_AMPLITUDE = window.Castos.config.amplitudeKey;

  AmplitudeClient.getInstance().init(
    API_KEY_AMPLITUDE,
    window.Castos.config.userEmail,
    {
      // optional configuration options
      includeUtm: true,
      includeGclid: true,
      includeReferrer: true,
    }
  );
  amplitude = AmplitudeClient;
}

export default amplitude;
